import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Modal from '../../components/Modal/Modal';
import EnergyLabelModal from './EnergyLabelModal';

// note title should be SHAPE energyLabelsTitle
// close btn energyLabelsCloseButton
export default class EnergyLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      labelImageLink: props.labelImageLink,
      src: props.src,
      alt: props.alt,
      title: props.title,
      closeText: props.closeText,
    };
    this.initiateModal = this.initiateModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  initiateModal() {
    this.setState({
      showModal: false,
    });
  }

  handleClick() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    return (
      <span>
        <Fragment>
          <a role="button" tabIndex={-1} onClick={this.handleClick}><img src={this.state.src} alt={this.state.alt} /></a>
        </Fragment>
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {this.state.showModal &&
            <Modal
              open={this.state.showModal}
              onClose={this.closeModal}
              title={this.state.title}
            >
              <EnergyLabelModal
                energyLabelImage={this.state.labelImageLink}
                closeModal={this.closeModal}
                closeText={this.state.closeText}
              />
            </Modal>
          }
        </ReactCSSTransitionGroup>
      </span>
    );
  }
}

EnergyLabel.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  labelImageLink: PropTypes.string,
  title: PropTypes.string,
  closeText: PropTypes.string,
};

EnergyLabel.defaultProps = {
  src: '',
  alt: '',
  labelImageLink: '',
  title: '',
  closeText: '',
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/EnergyLabels/EnergyLabel.js